export enum TrainerActionTypes {
    LIST_REQUEST = '@@Trainer/LIST_REQUEST',
    LIST_SUCCESS = '@@Trainer/LIST_SUCCESS',
    LIST_ERROR = '@@Trainer/LIST_ERROR',
    LIST_CLEAR = '@@Trainer/LIST_CLEAR',

    SELECT = '@@Trainer/SELECT',
    SELECTED = '@@Trainer/SELECTED',
    CLEAR_SELECTED = '@@Trainer/CLEAR_SELECTED',
    
    CREATE_REQUEST = '@@Trainer/CREATE_REQUEST',
    CREATE_SUCCESS = '@@Trainer/CREATE_SUCCESS',
    CREATE_ERROR = '@@Trainer/CREATE_ERROR',
    
    READ_REQUEST = '@@Trainer/READ_REQUEST',
    READ_SUCCESS = '@@Trainer/READ_SUCCESS',
    READ_ERROR = '@@Trainer/READ_ERROR',

    UPDATE_REQUEST = '@@Trainer/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@Trainer/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@Trainer/UPDATE_ERROR',
    
    DELETE_REQUEST = '@@Trainer/DELETE_REQUEST',
    DELETE_SUCCESS = '@@Trainer/DELETE_SUCCESS',
    DELETE_ERROR = '@@Trainer/DELETE_ERROR'
}

export interface TrainerUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
}
